import { ca } from '@cian/analytics';

export const trackChangeType = (ea, el, formId) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: ea,
    label: el,
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};
